export default {
  methods: {
    scrollTo(id, offset = -30) {
      var t = this;

      setTimeout(function() {
        t.$scrollTo(id, 300, {
          offset
        });
      }, 400);
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/scrollToMixin.js